import { render } from "./AllStudentView.vue?vue&type=template&id=5e87353b&scoped=true"
import script from "./AllStudentView.vue?vue&type=script&lang=js"
export * from "./AllStudentView.vue?vue&type=script&lang=js"

import "./AllStudentView.vue?vue&type=style&index=0&id=5e87353b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e87353b"]])

export default __exports__